export const checkInput = (Input, id) => {
    // console.log(Input,id)
    let textreturn = "";
    switch (Input) {
        case "PriceType":
            if (id === '0') {
                textreturn = "ราคาไม่รวมภาษี"
            } else if (id === '1') {
                textreturn = "ราคารวมภาษี"
            } else {
                textreturn = "ภาษีอัตราศูนย์"
            }
            break;
        case "BuyType":
            if (id === "0") {
                textreturn = "ซื้อสินค้า"
            } else if (id === "1") {
                textreturn = "บริการมีภาษี หัก ณ ที่จ่าย"
            }
            break;
        case "STOCKPROC":
            if (id === "0") {
                textreturn = "ขอรับคืนสินค้าและลดหนี้"
            } else if (id === "1") {
                textreturn = "ลดหนี้เนื่องจากราคาผิด"
            }
            break;

        case "ProductType":
            if (id === "0") {
                textreturn = "สินค้าซื้อมาขายไป"
            } else if (id === "1") {
                textreturn = "สินค้าบริการ"
            }
            else if (id === "2") {
                textreturn = "ไม่มีสต็อก (ทรัพย์สิน)"
            }
            break;
        case "SaleType":
            if (id === '0') {
                textreturn = "ขายสินค้า"
            } else{
                textreturn = "บริการมีภาษี หัก ณ ที่จ่าย"
            }
            break;
        case "PriceReturnType":
            if (id === '0') {
                textreturn = "คืนเงินสด"
            } else{
                textreturn = "เอาไว้หักชำระหนี้"
            }
            break;

        default:
            break;
    }
    return textreturn
} 